import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const Footer = styled.footer`
  padding: 20px 12px;
  background-color: ${colors.gray100};
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Content = styled.div`
  display: flex;
  gap: 6px;
`;

export const ButtonText = styled.span`
  text-decoration: underline;
  color: ${colors.blue};
  cursor: pointer;
`;
